import React from 'react';

const ManageSubscriptionIcon = () => (
  <svg
    className="MuiSvgIcon-root"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2zm-9 7h-5v-1.5h5V15zm3.5-1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S12 15.83 12 15s.67-1.5 1.5-1.5zm3 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S16 15.83 16 15s.67-1.5 1.5-1.5z" />
  </svg>
);

export default ManageSubscriptionIcon;
